<template>
  <div class="dashboard-container">
    <div class="header">
      <h2>项目销量统计</h2>
      <div class="filter">
        <el-radio-group v-model="time_dim" @change="handleFilterDim" size="mini">
          <el-radio-button label="今日" value="day"></el-radio-button>
          <el-radio-button label="本周" value="week"></el-radio-button>
          <el-radio-button label="本月" value="month"></el-radio-button>
        </el-radio-group>

        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="vertical-align: middle; width: 320px"
          size="mini"
          @change="handleTime"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
    </div>

    <el-table
      ref="projectTable"
      v-loading.body="listLoading"
      show-summary
      :data="list"
      element-loading-text="加载中 ..."
      border
      highlight-current-row
      :header-cell-style="{ background: '#f5f7fa' }"
      size="mini"
      :summary-method="handleSummaryMethod"
    >
      <el-table-column label="排名" width="100" align="center" prop="index"></el-table-column>
      <el-table-column
        label="名称"
        width="300"
        align="center"
        prop="project_name"
      ></el-table-column>
      <el-table-column
        label="营业额"
        width="200"
        align="center"
        prop="price"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        label="订单数"
        width="200"
        align="center"
        prop="order_num"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        label="出行人数"
        width="200"
        align="center"
        prop="user_num"
        sortable="custom"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <pagination
        small
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchListData"
      />
    </div>
  </div>
</template>

<script>
import { getProjectData } from '@/api/dashboard'

export default {
  name: 'ProjectData',
  data() {
    return {
      projectData: [],
      list: [],
      listLoading: true,

      time_dim: '今日',
      listQuery: {
        page: 1,
        size: 10,
        is_custom_time: 0,
        time_dim: 'day',
        start_time: '',
        end_time: '',
        orderby: ''
        /**
         * orderby:
         * price 营业额正序
         * -price 营业额倒序
         * order_num 订单数正序
         * -order_num 订单数倒序
         * user_num 出行人数正序
         * -user_num 出行人数倒序
         */
      },
      time: '',
      count: 0,
      currentSort: {
        prop: '',
        order: ''
      },
      agg: null
    }
  },
  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      const { prop, order } = this.currentSort
      const temp = {
        ...this.listQuery,
        // time_dim: this.time_dim === '今日' ? 'day' : this.time_dim === '本周' ? 'week' : 'month'
        orderby: `${order === 'ascending' ? '' : '-'}${prop}`
      }
      getProjectData(temp).then((res) => {
        console.log('res', res.data.data)
        const { data, agg } = res.data
        const list = data.map((item, index) => {
          return {
            ...item,
            index: index + 1
          }
        })
        this.projectData = list
        this.list = list.slice(0, this.listQuery.size)
        this.count = data.length
        this.agg = agg
        this.listLoading = false
      })
    },

    /**
     * @description: 汇总行
     */
    handleSummaryMethod({ columns = [] }) {
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }

        if (column.property === 'price') {
          if (this.agg && this.agg.price !== undefined) {
            sums[index] = this.agg.price
          } else {
            sums[index] = 0 // or some other default value
          }
          return
        }
        if (column.property === 'order_num') {
          if (this.agg && this.agg.order_num !== undefined) {
            sums[index] = this.agg.order_num
          } else {
            sums[index] = 0 // or some other default value
          }
          return
        }
        if (column.property === 'user_num') {
          if (this.agg && this.agg.user_num !== undefined) {
            sums[index] = this.agg.user_num
          } else {
            sums[index] = 0 // or some other default value
          }
          return
        }
      })
      console.log('sums', sums)

      return sums
    },
    /**
     * @description: 监听排序
     */
    sortChange({ prop, order }) {
      console.log('sortChange', prop, order)
      this.currentSort = { prop, order }
      this.fetchData()
    },
    /**
     * @description: 查看维度
     */
    handleFilterDim(dim) {
      this.time_dim = dim
      this.listQuery.time_dim = dim === '今日' ? 'day' : dim === '本周' ? 'week' : 'month'
      this.fetchData()
    },
    /**
     * @description: 按时间查看
     */
    handleTime(e) {
      if (e) {
        this.listQuery.start_time = e[0]
        this.listQuery.end_time = e[1]
        this.listQuery.is_custom_time = 1
      } else {
        this.listQuery.start_time = ''
        this.listQuery.end_time = ''
        this.listQuery.is_custom_time = 0
      }
      this.fetchData()
    },
    fetchListData() {
      this.list = this.projectData.slice(
        (this.listQuery.page - 1) * this.listQuery.size,
        this.listQuery.page * this.listQuery.size
      )
    }
  }
}
</script>
<style scoped lang="less">
.dashboard-container {
  padding: 0 10px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      font-size: 18px;
    }
    .filter {
      display: flex;
      align-items: center;
      .el-radio-group {
        margin-right: 10px;
      }
    }
  }
}
</style>
